import requests from "./httpService";

const SubCategoryServices = {

    getSubCategory: async () =>{
        return requests.get(`/subcategory`);
    },
    
    getCategoryActive: async () =>{
        return requests.get(`/category/active`);
    },
    updateCategory : async (id,body) =>{
        return requests.patch(`/subcategory/${id}`,body);
    },

    createSubCategory : async (body) =>{
    
        return requests.post(`/subcategory`,body);
    },
    
    deleteSubCategory : async (id) =>{
        return requests.delete(`/subcategory/${id}`);
    }

  


}
export default SubCategoryServices;